// extracted by mini-css-extract-plugin
module.exports = {"Stories":"Stories_Stories__8kOHs"};